import React from 'react'
import PropTypes from 'prop-types'
import { Switch, Route, Redirect } from 'react-router-dom'
import AccPageList from './AccPageList';
import AccPageSet from './AccPageSet';

import "./SettingAccPage.scss"

function SettingAccPage(props) {
  const { 
    match
  } = props;

  return (
    <div className="page-container">
      <Switch>
        <Route path={`${match.url}/list`}
          render={props => <AccPageList {...props} basePath={match.url} />}
        />
        <Route path={`${match.url}/add`}
          render={props => <AccPageSet {...props} basePath={match.url} />}
        />
        <Route path={`${match.url}/edit/:id`}
          render={props => <AccPageSet {...props} basePath={match.url} />}
        />
        <Redirect to={`${match.url}/list`} />
      </Switch>
    </div>
  )
}

SettingAccPage.propTypes = {

}

export default SettingAccPage

